
import * as ActionType from "./order.type";

const initialState = {
  order: [],
  totalOrder: 0,
  loading: false,
  error: null,
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_ORDER_REQUEST:
    case ActionType.GET_ORDER_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionType.GET_ORDER_SUCCESS:
    case ActionType.GET_ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case ActionType.GET_ORDER_FAILURE:
    case ActionType.GET_ORDER_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ActionType.GET_ORDER:
      return {
        ...state,
        loading: false,
        error: null,
        order: action.payload.orders,
        totalOrder: action.payload.totalOrders,
      };
   
    case ActionType.UPDATE_ORDER:
      
      return {
        ...state,
        order: state.order.map((data) =>
          data._id === action.payload.updateOrder._id
            ? action.payload.updateOrder
            : data
        ),
        orderDetail: action.payload.updateOrder,
      };
    case ActionType.GET_ORDER_DETAIL:
      
      return {
        ...state,
        loading: false,
        error: null,
        orderDetail: action.payload,
      };
    default:
      return state;
  }
};
